class CartOpen extends HTMLElement {
  constructor() {
    super();
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        document.addEventListener("click", (e) => {
          const b = e.target.closest("button");
          if (b && b.matches(".site-header__cart")) {
            this.openCart();
          }
        });
      },
      false
    );
  }

  openCart() {
    document.querySelector(".flyout").classList.add("active");
    document.body.style.overflow = "hidden";
  }
}

customElements.define("cart-open", CartOpen);

class SiteCart extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.cont = this.querySelector(".cart__container");
    this.initClickEvents();
  }

  initClickEvents() {
    document.addEventListener("click", async (e) => {
      const t = e.target;
      const b = t.closest("button");
      if (
        (b && b.matches(".flyout__veil")) ||
        (b && b.matches(".flyout__close"))
      ) {
        e.preventDefault();
        t.closest(".flyout").classList.remove("active");
        document.body.removeAttribute("style");
      }
    });
  }
}

customElements.define("site-cart", SiteCart);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: "#main-cart-items",
      },
      {
        id: "main-cart-footer",
        section: "main-cart-footer",
        selector: "#main-cart-footer",
      },
      {
        id: "main-cart-header",
        section: "main-cart-header",
        selector: "#main-cart-header",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#cart-icon-bubble",
      },
    ];
  }

  renderCartSections(result) {
    this.getSectionsToRender().forEach((section) => {
      const elToReplace = document.querySelector(section.selector);
      const footer = document.getElementById("main-cart-footer");
      if (elToReplace) {
        elToReplace.innerHTML = this.getSectionInnerHTML(
          result.sections[section.section],
          section.selector
        );

        if (section.id === "main-cart-header") {
          document
            .querySelector(".cart__close.flyout__close")
            .addEventListener("click", function () {
              document.querySelector(".flyout").classList.remove("active");
            });
        }

        if (result.items.length > 0) {
          this.classList.remove("is-empty");
          footer.classList.remove("is-empty");
        } else {
          this.classList.add("is-empty");
          footer.classList.add("is-empty");
        }
      }
    });
  }

  async updateQuantity(line, quantity) {
    this.enableLoading(line);

    const onSuccess = (result) => {
      this.renderCartSections(result);
      this.disableLoading();
    };

    const onError = () => {
      this.disableLoading();
    };

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
    };

    fetch("/cart/change", {
      ...config,
      body: JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        onSuccess(result);
      })
      .catch(() => {
        onError();
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.add("active")
    );
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled");
    this.querySelectorAll(".loading-overlay").forEach((overlay) =>
      overlay.classList.remove("active")
    );
  }
}

customElements.define("cart-items", CartItems);
